export enum NoteParentTypeEnum {
  Unknown = 0,
  Location = 1,
  Company = 2,
  User = 3,
  BoxUpdate = 4,
  Connector = 5
}

export type NoteParentType = keyof typeof NoteParentTypeEnum;

export enum NoteTypeEnum {
  Unknown = 0,
  Internal = 1,
  Protected = 2
}

export type NoteType = keyof typeof NoteTypeEnum;

export interface CreateNoteRequest {
  Contents: string;
  ParentId: number;
  ParentType: NoteParentTypeEnum;
  Type: NoteTypeEnum;
}

export interface Note {
  CanUserDelete: boolean;
  Contents: string;
  Created: string;
  CreatedUTC: string;
  Id: number;
  Type: NoteType;
  UserId: number;
  UserName: string;
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type GetNotesParams = {
  ParentId: number;
  ParentType: NoteParentTypeEnum;
  StartIndex: number;
  Take: number;
};
